<template>
  <el-dialog :visible.sync="visible" width="70%" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '160px'">
      
      <h3>机构信息</h3>
      <div class="inline-box">
        <el-form-item label="所属机构" prop="publishChannels" class="styW">
          <el-input v-model="dataForm.publishChannels" placeholder="所属机构"></el-input>
        </el-form-item>
        <el-form-item label="BD/PM-没" prop="publishChannels" class="styW">
          <el-input v-model="dataForm.publishChannels" placeholder="所属机构"></el-input>
        </el-form-item>
      </div>
      <h3>产品大纲</h3>
      <div class="inline-box">
      <el-form-item label="产品大类" prop="productCategory" class="styW">
         <el-select v-model="dataForm.productCategory" filterable clearable placeholder="产品大类" class="hundred">
           <el-option 
                     v-for="item in productCategories"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"
           ></el-option>
         </el-select>
      </el-form-item>
      <el-form-item label="产品类型" prop="productType" class="styW">
        <el-select v-model="dataForm.productType" filterable clearable placeholder="产品类型" class="hundred">
          <el-option 
                    v-for="item in productTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
          </el-option>
        </el-select>
    </el-form-item>
      <el-form-item label="产品名称" prop="productName" class="styW">
          <el-input v-model="dataForm.productName" placeholder="产品名称"></el-input>
      </el-form-item>
      <el-form-item label="产品有效时间" prop="productLimit" class="styW">
       <el-date-picker
               v-model="dataForm.productLimit"
               type="date"
               placeholder="产品有效时间"
               value-format="yyyy-MM-dd HH:mm:ss">
       </el-date-picker>
      </el-form-item>
      
        <el-form-item  label="产品图标" prop="productLogo" class="hundred">
          <!-- <el-input v-model="dataForm.productLogo" placeholder="产品图标"></el-input> -->
          <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
          <!-- <img width="100%" :src="dialogImageUrl" alt=""> -->
        </el-dialog>
        </el-form-item>
        <el-form-item label="最高额度-没" prop="creditAmount" class="styW">
            <el-input v-model="dataForm.creditAmount" placeholder="授信额度"></el-input>
        </el-form-item>
      <!-- <el-form-item label="授信额度" prop="creditAmount" class="styW">
          <el-input v-model="dataForm.creditAmount" placeholder="授信额度"></el-input>
      </el-form-item> -->
        
        <el-form-item label="还款方式" prop="repaymentType" class="styW">
          <el-input v-model="dataForm.repaymentType" placeholder="还款方式"></el-input>
        </el-form-item>
       <el-form-item label="产品利率" prop="productRate" class="styW">
          <el-input v-model="dataForm.productRate" placeholder="产品利率"></el-input>
       </el-form-item>
      
      <!-- <el-form-item label="最高返佣" prop="maxRebate" class="styW">
          <el-input v-model="dataForm.maxRebate" placeholder="最高返佣"></el-input>
      </el-form-item> -->
     

      <el-form-item label="提前还款-没" prop="" class="styW">
          <el-select v-model="dataForm.productType" filterable clearable placeholder="产品类型" class="hundred">
            <el-option 
                      v-for="item in withdrawal"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="贷款期限-没" prop="maxRebate" class="styW">
          <el-input v-model="dataForm.maxRebate" placeholder="贷款期限"></el-input>
      </el-form-item>
      <el-form-item label="备注-没" prop="maxRebate" class="styW">
          <el-input v-model="dataForm.maxRebate" placeholder="贷款期限"></el-input>
      </el-form-item>
      <el-form-item label="准入区域" prop="productAccessArea" class="hundred">
          <el-button type="" @click="productAccessAreas()">准入区域设置</el-button>
      </el-form-item> 
    </div>
      <!-- <el-form-item label="注意事项" prop="productNotice" class="styW">
          <el-input v-model="dataForm.productNotice" placeholder="注意事项"></el-input>
      </el-form-item> -->
      <h3>进件要求</h3>
     
      <el-form-item label="个人要求" prop="productPersonCondition"  class="hundred">
          <!-- <el-input
          class="hundred" 
          type="textarea"
          v-model="dataForm.productPersonCondition"
          :rows="2"
          placeholder="个人要求">
          </el-input> -->
          <wealth v-model="dataForm.productPersonCondition" :valuemy="dataForm.productPersonCondition"></wealth>
      </el-form-item> 

      <el-form-item label="征信要求" prop="productCreditRequirement"  class="hundred">
        <wealth v-model="dataForm.productCreditRequirement" :valuemy="dataForm.productCreditRequirement"></wealth>
      </el-form-item> 

      <el-form-item label="企业要求" prop="productCompanyCondition"  class="hundred">
          <wealth v-model="dataForm.productCompanyCondition" :valuemy="dataForm.productCompanyCondition"></wealth>
      </el-form-item> 
      <el-form-item label="其他要求" prop="productOtherRequirement" class="hundred">
          <wealth v-model="dataForm.productOtherRequirement" :valuemy="dataForm.productOtherRequirement"></wealth>
      </el-form-item>
      <h3>进件资料</h3>
      <el-form-item label="进件资料" prop="productApplyInfo"  class="hundred">
          <wealth  v-model="dataForm.productApplyInfo" :valuemy="dataForm.productApplyInfo"></wealth>
      </el-form-item> 

      <!-- <el-form-item label="所需资料"  prop="productRequiredinfo" class="hundred">
          <el-input
          class="hundred" 
          type="textarea"
          v-model="dataForm.productRequiredinfo"
          :rows="2"
          placeholder="所需资料">
          </el-input>
      </el-form-item> -->
        <!-- <el-form-item label="返佣说明" prop="productRebateInfo" class="styW">
            <el-input v-model="dataForm.productRebateInfo" placeholder="返佣说明"></el-input>
        </el-form-item> -->
          <!-- <el-form-item label="企业要求" prop="productCompanyCondition" class="styW">
          <el-input v-model="dataForm.productCompanyCondition" placeholder="企业要求"></el-input>
      </el-form-item> -->
     
      
      <el-form-item label="进件流程" prop="productApplyFlow"  class="hundred">
          <el-input
          class="hundred" 
          type="textarea"
          v-model="dataForm.productApplyFlow"
          :rows="2"
          placeholder="进件流程料">
          </el-input>
      </el-form-item> 
      <h3>分润设置</h3>
      <el-form-item label="结算状态-没" prop="" class="styW">
          <el-select v-model="dataForm.productType" filterable clearable placeholder="产品类型" class="hundred">
            <el-option 
                      v-for="item in closeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
            </el-option>
          </el-select>
      </el-form-item>
      <h3>申请流程</h3>
      <el-form-item  label="申请详细流程说明链接" prop="" class="styW">
        <el-input
          class="hundred" 
          :rows="2"
          placeholder="申请详细流程说明链接">
          </el-input>
      </el-form-item>

      <!-- <el-form-item label="其它要求" prop="productOtherCondition" class="styW">
          <el-input v-model="dataForm.productOtherCondition" placeholder="其它要求"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="产品结算方式" prop="productSettlementMode" class="styW">
          <el-input v-model="dataForm.productSettlementMode" placeholder="产品结算方式"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="产品简介" prop="productIntro" class="styW">
          <el-input v-model="dataForm.productIntro" placeholder="产品简介"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="产品说明" prop="productExplain" class="styW">
          <el-input v-model="dataForm.productExplain" placeholder="产品说明"></el-input>
      </el-form-item> -->
       <!-- <el-form-item label="产品等级 A-F" prop="productLevel" class="styW">
          <el-input v-model="dataForm.productLevel" placeholder="产品等级 A-F"></el-input>
      </el-form-item> -->
      
      <!-- <el-form-item label="机构负责人" prop="channelPm">
          <el-input v-model="dataForm.channelPm" placeholder="机构负责人"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="发布时间" prop="publishTime" class="styW">
          <el-date-picker
                  v-model="dataForm.publishTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item> -->
      <!-- <el-form-item label="下架时间" prop="unshelveTime" class="styW">
          <el-date-picker
                  size="large"
                  v-model="dataForm.unshelveTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item> -->
      <!-- <el-form-item label="下架备注" prop="unshelveRemark" class="styW">
          <el-input v-model="dataForm.unshelveRemark" placeholder="下架备注"></el-input>
      </el-form-item> -->
      <h3>上架配置</h3>
        <el-form-item label="上架" prop="status" class="styW">
          <el-select v-model="dataForm.status" filterable clearable placeholder="请选择" class="hundred">
	          <el-option
	                  v-for="item in statusList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
       </el-form-item> 

       <el-form-item label="产品对接方式" prop="status" class="styW">
          <el-select v-model="dataForm.productTypes" filterable clearable placeholder="请选择" class="hundred">
	          <el-option
	                  v-for="item in productTypes"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
       </el-form-item> 

       <el-form-item label="H5链接" prop="status" class="styW">
          <el-input v-model="dataForm.productSettlementMode" placeholder="产品结算方式"></el-input>
       </el-form-item> 
       <el-form-item label="上传二维码" prop="status" class="styW">
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
            <!-- <img width="100%" :src="dialogImageUrl" alt=""> -->
          </el-dialog>
       </el-form-item> 

      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
    <el-dialog
      width="60%"
      title="准入区域设置"
      :visible.sync="innerVisible"
      append-to-body>
       
      <accessArea ref="cityRef"></accessArea>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="innerVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="gitCity()">确 定</el-button>
      </div>
    </el-dialog>
   
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import wealth from '../../../components/wealth.vue'
import accessArea from '../../../components/wx/accessArea.vue'
import cityobj from '@/utils/city'

export default {
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      visible: false,
      innerVisible: false,
      citys: [],
      cityobj: cityobj,
      productTypeList: [],
      productCategories: [],
      closeList:[
        {
            'label':'已授信',
            'value':0,
        },
        {
            'label':'放款成功',
            'value':1,
        }
      ],
      statusList: [
        {
            'label':'未上架',
            'value':0,
        },
        {
            'label':'已上架',
            'value':1,
        }
      ],
      productTypes: [
        {
            'label':'H5',
            'value':0,
        },
        {
            'label':'二维码',
            'value':1,
        }
      ],
      dataForm: {
        productTypes: '',
        id: '',
        productCode: '',
        productName: '',
        productLogo: '',
        productCategory: '',
        productType: '',
        creditAmount: '',
        maxRebate: '',
        productRate: '',
        productLimit: '',
        repaymentType: '',
        productNotice: '',
        productRequiredinfo: '',
        productRebateInfo: '',
        productCompanyCondition: '',
        productPersonCondition: '',
        productCreditRequirement: '',
        productOtherRequirement: '',
        productAccessArea: '',
        productApplyInfo: '',
        productApplyFlow: '',
        productOtherCondition: '',
        productSettlementMode: '',
        productIntro: '',
        productExplain: '',
        productLevel: '',
        publishChannels: '',
        publishTime: '',
        unshelveTime: '',
        unshelveRemark: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: '',
        status: '',
        channelPm:'',
      },
      withdrawal: [{
        value: '可提前还款，无提前还款违约金',
        label: '可提前还款，无提前还款违约金'
      }]
    }
  },
  computed: {
    dataRule () {
      return {
        // channelPm: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productCode: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productName: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productLogo: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        productCategory: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // productType: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // creditAmount: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // maxRebate: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productRate: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productLimit: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // repaymentType: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productNotice: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productRequiredinfo: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productRebateInfo: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productCompanyCondition: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productPersonCondition: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productCreditRequirement: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productOtherRequirement: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // // productAccessArea: [
        // //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // // ],
        // productApplyInfo: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productApplyFlow: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productOtherCondition: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productSettlementMode: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productIntro: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productExplain: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // productLevel: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // publishChannels: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // publishTime: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // unshelveTime: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // unshelveRemark: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // updateBy: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // updateTime: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // deleteTime: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // status: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ]
      }
    }
  },
  components:{
    wealth,
    accessArea,
  },
  methods: {
  
    init () {
      this.visible = true
      this.getCityOptions()
      this.getProductTypeOptions()
      this.getproductCategoriesOptions()
      this.cityobj.provinces.forEach(item => {
            item.istrue = false
            item.isIndeterminate = false
            item.cities.forEach(item1 => {
                item1.istrue = false
            })
        })
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
    productAccessAreas(){
        this.innerVisible = true
        this.$nextTick(()=>{
         
          if(this.dataForm.id){
          
            this.$refs.cityRef.init(JSON.parse(this.dataForm.productAccessArea))
          }else{
          
            this.$refs.cityRef.init(this.cityobj)
          }
        })
      
    },
    gitCity(){
      this.dataForm.productAccessArea = JSON.stringify(this.$refs.cityRef.cityobj) 
      this.innerVisible = false
      console.log(this.dataForm.productAccessArea)
    },
     //初始化下拉框中的选项
     async getCityOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.citys=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.citys.push({label:element.dictLabel,value:element.dictValue})
                  })
                  /*let citys = {}
                  for(let i = 0; i< res.data.length; i++){
                      citys[i].value=res.data[i].dictValue
                      citys[i].label=res.data[i].dictLabel
                  }*/
              }
          }).catch(() => {})
      },
     
      async getproductCategoriesOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=product_categories`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
               this.productCategories = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                   this.productCategories.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
      async getProductTypeOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=product_type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
               this.productTypeList = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                   this.productTypeList.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/slproduct/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        // if(res.data.productAccessArea){
        //   res.data.productAccessArea = res.data?.productAccessArea.split('|')
        // }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
       
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
    
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        // if(this.dataForm.productAccessArea){
        //   this.dataForm.productAccessArea = this.dataForm.productAccessArea.join('|')
        // }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slproduct/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style lang="scss" scoped>

.inline-box{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
   }
   .el-form-item{
    margin-right: 40px;
   }
.styW{
  width: 400px;
}
::v-deep .el-date-editor--date{
  width: 100%;
}
h3{
  margin: 30px 0;
}

</style>
